module.exports = __webpack_public_path__ + "img/attack_wood.6005600f.png";